<a
  #infoIcon
  [bomPopover]="content$"
  [triggers]="['click', 'enter']"
  (initialInvoke)="intialInvoke()"
>
  <u *ngIf="linkBeforeIcon">
    {{ linkBeforeIcon }}
  </u>
  <svg class="icon-svg">
    <use xlink:href="#help-circle-outline"></use>
  </svg>
  <u *ngIf="linkAfterIcon">
    {{ linkAfterIcon }}
  </u>
</a>
